import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { useSelector } from "react-redux";
import { wrapper } from "store";
import OneTrustX from '@/bit/components/components.one-trust-x';
import "@/styles/globals.scss";
import "@/styles/skeleton.scss";

 /* [STYLES] begins */ 
 import '@/styles/globals.scss'; 
 import '@/styles/grid.scss'; 
 import '@/styles/colors.scss'; 
 import '@/styles/fonts.scss';
 
 /* [STYLES] ends */ 

import "@/styles/card.scss";
import "@/styles/image-slider.scss";
import "@/styles/tv-card.scss";
import "@/styles/product-modal.scss";
import "@/styles/tv-filters.scss";


const App = ({ Component, pageProps, ...rest }) => {
  const Modal = useSelector((state) => state.modals.Modal);

  return (
    <>
      <Component {...pageProps} />
      {Modal && Modal}
      <OneTrustX />
      {/* APP DELIMITER */}
    </>
  );
};

export default wrapper.withRedux(App);
